import { userStore } from "../gStore/user.store";
import { DailyChallengeWithScores } from "../interfaces/dailyChallenge.interface";
import axios from "axios";

class DailyChallengeService {
  baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_BACKEND || "";
  }

  getDailyChallenge() {
    return new Promise<DailyChallengeWithScores>((resolve, reject) => {
      axios({
        method: "GET",
        url: `${this.baseUrl}/daily_challenge/api/current?userId=${userStore.data.user.id}`,
      })
        .then(
          (res: {
            data:
              | { success: true; data: DailyChallengeWithScores }
              | { success: false; data: string };
          }) => {
            if (res.data.success) {
              resolve(res.data.data);
            } else {
              reject(res.data.data);
            }
          }
        )
        .catch((err: any) => {
          console.log(err.message);
          resolve({
            id: 0,
            game_id: 'Not Found',
            date: new Date().toString(),
            scores:
              {
                user: null,
                top: []
              }
          });
        });
    });
  }
}

export const dailyChallengeService = new DailyChallengeService();
